import { DateRange } from './DateRange';

export const isEmptyDateRange = <T extends Date | string = Date>(
  dateRange: Partial<DateRange<T>> | DateRange<T>
): dateRange is Partial<DateRange<T>> => !dateRange.from && !dateRange.to;
